import axios from '~/clients/axios';
import { NEW_CAR_CUSTOMIZE } from '~/constants/endpoints';
import type CustomizeRequest from '~/contracts/new-cars/CustomizeRequest';
import type CustomizeResponse from '~/contracts/new-cars/CustomizeResponse';

export default function fetchCustomizeOptions(
  request: CustomizeRequest,
  controller: AbortController
): Promise<CustomizeResponse> {
  return axios
    .post(NEW_CAR_CUSTOMIZE, request, { signal: controller.signal })
    .then(res => res.data);
}
